export enum TopicElementTypeEnum {
  DOCUMENT = 'DOCUMENT',
  TEXT = 'TEXT',
  LINK = 'LINK',
  MEDIA = 'MEDIA',
  QUIZ_SINGLE = 'QUIZ_SINGLE',
  QUIZ_MULTI = 'QUIZ_MULTI',
  QUIZ_OPEN = 'QUIZ_OPEN',
  QUIZ_FREE = 'QUIZ_FREE',
  GOOGLE_DRIVE_FILE = 'GOOGLE_DRIVE_FILE',
  MICROSOFT_FILE = 'MICROSOFT_FILE',
  SCORM = 'SCORM',
  EMBED_LINK = 'EMBED_LINK'
}

export const QuizElementTypes = [
  TopicElementTypeEnum.QUIZ_SINGLE,
  TopicElementTypeEnum.QUIZ_MULTI,
  TopicElementTypeEnum.QUIZ_OPEN,
  TopicElementTypeEnum.QUIZ_FREE
]

export const QuizElementTypesWithChoices = [
  TopicElementTypeEnum.QUIZ_SINGLE,
  TopicElementTypeEnum.QUIZ_MULTI,
  TopicElementTypeEnum.QUIZ_OPEN
]
